import { ConversationChannelTypeExtended } from '@provision/chat-utils';
import { useGroupRules, UserGroupRules } from 'src/graphql';

export const DEFAULT_MESSAGE_TYPE_OPTIONS = [
  {
    value: ConversationChannelTypeExtended.InternalNote,
    label: 'Internal Note',
  },
  {
    value: ConversationChannelTypeExtended.Chat,
    label: 'Public Reply',
  },
];

export const DEFAULT_CREATE_CONVERSATION_TYPE_OPTIONS = [
  // TODO: add Chat option back once we are ready to introduce client gateway
  // {
  //   value: ConversationChannelTypeExtended.Chat,
  //   label: 'Chat',
  // },
  {
    value: ConversationChannelTypeExtended.InternalNote,
    label: 'Internal Note',
  },
  {
    value: ConversationChannelTypeExtended.Email,
    label: 'Email',
  },
];
export const RESTRICTED_CONVERSATION_TYPE_OPTIONS = [
  {
    value: ConversationChannelTypeExtended.InternalNote,
    label: 'Internal Note',
  },
];

type ConversationOrigin = 'chat' | 'create-conversation-form';
export const useConversationTypeOptions = (origin: ConversationOrigin) => {
  const { groupRules } = useGroupRules();
  const defaultConversationTypeOptions =
    origin === 'create-conversation-form'
      ? DEFAULT_CREATE_CONVERSATION_TYPE_OPTIONS
      : DEFAULT_MESSAGE_TYPE_OPTIONS;

  const messageTypeOptions = groupRules[
    UserGroupRules.AccessToSendExternalConversationMessages
  ]
    ? defaultConversationTypeOptions
    : RESTRICTED_CONVERSATION_TYPE_OPTIONS;
  return messageTypeOptions;
};
